import { render, staticRenderFns } from "./QuestionnaireEditor.vue?vue&type=template&id=71f9ff7e&scoped=true&"
import script from "./QuestionnaireEditor.vue?vue&type=script&lang=ts&"
export * from "./QuestionnaireEditor.vue?vue&type=script&lang=ts&"
import style0 from "./QuestionnaireEditor.vue?vue&type=style&index=0&id=71f9ff7e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71f9ff7e",
  null
  
)

export default component.exports